import Cards from "../../component/Cards";
import PageLayout from "../../component/PageLayout";
import IconHome from "../../component/SvgIcon/IconHome";
import UsersCards from "../../component/UsersCards";

export default function Dashboard() {
  return (
    <PageLayout icon={<IconHome />} pagetitle="Dashboard">  
    <div className="topspace">
    <div className="container-fluid">
      <Cards/> 
      <UsersCards/>
      </div>   
      </div>    
    </PageLayout>    
  );
}
